import "./intro.css"
function Intro () {
    return (
        <>
        <h1 className="head"> ANKARA CONDENSED MATTER COLLOQUIA</h1>
        {/* <h1 className="head"> COLLOQUIA</h1> */}
        </>

    )
}

export default Intro